module.exports = __webpack_public_path__ + "static/img/5g4.197c6c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5g4.png
// module id = 8N1B
// module chunks = 21